import ownerWindow from './ownerWindow';
export default function getComputedStyle(node, psuedoElement) {
  return ownerWindow(node).getComputedStyle(node, psuedoElement);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap/node_modules/dom-helpers/esm/getComputedStyle.js
// module id = 1080
// module chunks = 0